
import { styled } from '@mui/material/styles';

import ToggleButton from "@mui/material/ToggleButton";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    '&.MuiToggleButton-standard': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.toggleButton
    },
    '&.Mui-selected, &.Mui-selected:hover': {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.button
    }
}));

export default StyledToggleButton;
